export class UpdateVaultResponse {
    'vault';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vault",
            "baseName": "vault",
            "type": "BackupVault",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateVaultResponse.attributeTypeMap;
    }
    constructor() {
    }
}
